import React, { useState, useEffect } from 'react'  
import { Modal, Table } from 'antd'
import { useFeiyongListQuery } from '../../store/DianShangYeWuApi'
import ExpenseCheck from './ExpenseCheck'
import classes from './expense.module.css'
function ExpenseListWithId(props) {
    const [open, setOpen] = useState(false)
    const name = Array.isArray(props.id) ? props.id.join('，') : (props.id || '')
    const names = name.length > 20 ? name.slice(0, 20) + '…' : name;
    const [list, setList] = useState([])
    const {data, isSuccess} = useFeiyongListQuery({fy_id:props.id,fy_qy_id:props.qy_id});       
    useEffect(() => {
        if(isSuccess){
            setList(data.Result)
        }
    }, [data, isSuccess])
    const columns = [
        {
            title: '费用客户',
            dataIndex: 'fy_kh_name',
            key: 'fy_kh_name',
            render: (text, record) => {
                return <ExpenseCheck 
                            fy_id={record.fy_id} 
                            yh_id={props.yh_id}
                            yh_name={props.yh_name}
                            qy_id={props.qy_id}
                            qy_name={props.qy_name}
                            fy_kh_id={record.fy_kh_id}
                            fy_kh_name={record.fy_kh_name}
                            fy_price={record.fy_price}
                            fy_content={record.fy_content}
                            fy_date={record.fy_date}
                            fy_date_end={record.fy_date_end}
                            fy_bzd_name={record.fy_bzd_name}
                        />
                }
        },
        {
            title: '费用金额',
            dataIndex: 'fy_amount',
            key: 'fy_amount',
            render: (text, record) => <span style={{color:'#3366FF'}}>￥{Number(record.fy_amount).toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}</span>
        },
        {
            title: '编号',
            dataIndex: 'fy_id',
            key: 'fy_id',
            width: 60,
        },
    ]
    return (
        <>
            <a onClick={() => setOpen(true)}>{names}</a>
            <Modal 
                open={open} 
                onCancel={() => setOpen(false)}
                title='费用单列表'
                footer={null}
            >
                <Table 
                    columns={columns} 
                    dataSource={list} 
                    rowKey='fy_id'
                    className={classes.orangeHeader}
                    size='small'
                    bordered
                    pagination={{
                        showTotal: (total) => `共${total}条`,
                        pageSize: 50,
                        placement: 'bottomCenter',
                        showSizeChanger: true,
                    }}
                    summary={pageData => {
                        const total = pageData.reduce((sum, row) => sum + Number(row.fy_amount || 0), 0);
                        return (
                            <Table.Summary.Row>
                                <Table.Summary.Cell index={0}></Table.Summary.Cell>
                                <Table.Summary.Cell index={1} colSpan={1}>
                                    <span style={{color:'#3366FF'}}>合计：￥{Number(total).toLocaleString('zh-CN', {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                })}</span>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={2} colSpan={columns.length - 2} />
                            </Table.Summary.Row>
                        );
                    }}
                />
            </Modal>
        </>
    )
}

export default ExpenseListWithId